// @flow

import { combineReducers } from 'redux';

import {
  priceOfStayReducer,
  type PriceOfStayState,
} from 'Store/price-remote/price-of-stay/priceOfStay.reducer';
import {
  allInclusiveServicesReducer,
  type AllInclusiveServicesState,
} from 'Store/price-remote/all-inclusive-services/allInclusiveServices.reducer';

export type PriceRemoteState = {
  priceOfStay: PriceOfStayState,
  allInclusiveServices: AllInclusiveServicesState,
};

export const priceRemoteReducer: PriceRemoteState = combineReducers({
  allInclusiveServices: allInclusiveServicesReducer,
  priceOfStay: priceOfStayReducer,
});
